﻿import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

const TireResultsGrid = ({ items, firmanavn }) => {
    const fn = firmanavn || 'nbf';
    // Sorting and filtering apply to the whole dataset, since TireFinder loads all results in one request

    const TitleCellRenderer = (props) => (
        <a href={`/${fn}${props.data.URL}`}>{props.value}</a>
    );

    const ActionsCellRenderer = (props) => {
        const item = props.data;
        const handleAddToCart = (e) => {
            e.preventDefault();
            if (typeof window !== 'undefined' && window.addItemToCart) {
                window.addItemToCart(e.currentTarget);
            }
        };
        return (
            <div style={{ display: 'flex', gap: '6px', alignItems: 'center', height: '100%' }}>
                <a
                    href="#"
                    data-storageid={item.StorageId}
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleAddToCart}
                >
                    Forespørsel
                </a>
                {item.PartIsAvailableForPurchase && (
                    <form method="post" action={`/${fn}/checkout/step1`} style={{ margin: 0 }}>
                        <input type="hidden" name="storageid" value={item.StorageId} />
                        <button type="submit" className="btn btn-sm btn-primary">Kjøp</button>
                    </form>
                )}
            </div>
        );
    };

    const columnDefs = [
        { headerName: "Tittel", field: "Title", flex: 2, minWidth: 150, cellRenderer: TitleCellRenderer },
        { headerName: "Felg", field: "RimSize", width: 80, valueFormatter: p => p.value ? `${p.value}"` : '' },
        { headerName: "Avvik %", field: "deviation", width: 100, valueFormatter: p => p.value != null ? `${p.value.toFixed(2)}%` : '' },
        { headerName: "Pris", field: "Price", width: 120, valueFormatter: p => p.value ? `${p.data.PriceThousandSeperated} kr` : 'Ring for pris' },
        { headerName: "Årsmodell", field: "YearModel", width: 110 },
        { headerName: "Km", field: "MileageThousandSeperated", width: 100 },
        { headerName: "Forhandler", field: "DealerName", flex: 1, minWidth: 120 },
        { headerName: "", field: "actions", width: 200, cellRenderer: ActionsCellRenderer, sortable: false, filter: false },
    ];

    return (
        <div className="ag-theme-alpine" style={{ width: '100%' }}>
            <AgGridReact
                rowData={items}
                columnDefs={columnDefs}
                domLayout="autoHeight"
                pagination={true}
                paginationPageSize={100}
                paginationPageSizeSelector={[20, 50, 100, 200]}
                suppressMovableColumns={true}
                rowHeight={48}
            />
        </div>
    );
};

export default TireResultsGrid;

